module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }